import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { classLeaderboardsCrudStateConfig } from "../consts";

export const { fetchActionFactory: fetchClassLeaderboardActionFactory } =
  makeCrudStateActionFactories(classLeaderboardsCrudStateConfig);
